<template>
    <div>
        <Head><title>Orders</title></Head>
        <h1 class="mb-8 text-3xl font-bold">Orders</h1>
        <div class="flex items-center justify-between mb-6">
            <div class="flex items-center justify-between mb-6">
                <search-filter :show-input="true" v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
                    <template #dateFilter>
                        <date-picker v-model="form.date" :range="true" :time-picker="false"
                                     :enable-time-picker="false" input-class-name="dp-custom-input" :multi-calendars="2"
                                     :preset-ranges="presetRanges" auto-apply>
                        </date-picker>
                    </template>
                </search-filter>
            </div>

        </div>
        <!--cards wrapper-->
        <div class="container items-center px-4 py-8 m-auto mt-5">
            <div class="flex flex-wrap pb-3 mx-4 md:mx-24 lg:mx-0">

                <summary-card title="Total Orders" :totals=ordersCount
                              :percentage_change=summary.orders_change.percentage
                              :change_direction=summary.orders_change.hasIncreased #cardIcon>
                    <icon name="cart" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

                <summary-card title="MPesa Orders" :totals=mpesaOrders
                              :percentage_change=summary.mpesa_orders_change.percentage
                              :change_direction=summary.mpesa_orders_change.hasIncreased #cardIcon>
                    <icon name="cart" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

                <summary-card title="PayPal Orders" :totals=paypalOrders
                              :percentage_change=summary.paypal_orders_change.percentage
                              :change_direction=summary.paypal_orders_change.hasIncreased #cardIcon>
                    <icon name="cart" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

                <summary-card title="Incomplete Orders" :totals=inCompleteOrders
                              :percentage_change=summary.unsuccessful_orders_change.percentage
                              :change_direction=summary.unsuccessful_orders_change.hasIncreased #cardIcon>
                    <icon name="cart" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

            </div>
        </div>

        <Table :resource="orders">

        </Table>
    </div>


</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import SummaryCard from "@/Shared/SummaryCard";
import {Table} from "@protonemedia/inertiajs-tables-laravel-query-builder";
import {ref} from "vue";
import {
    endOfMonth,
    endOfYear,
    endOfYesterday,
    startOfMonth,
    startOfYear,
    startOfYesterday,
    subDays,
    subMonths, subYears
} from "date-fns";

export default {
    components: {
        SummaryCard,
        Head,
        Icon,
        Link,
        Pagination,
        SearchFilter,
        Table
    },
    layout: Layout,
    props: {
        filters: Object,
        orders: Object,
        summary: Object,
        ordersCount: Number,
        mpesaOrders: Number,
        paypalOrders: Number,
        inCompleteOrders: Number,

    },
    data() {
        return {
            form: {
                search: this.filters.search,
                date: this.filters.date,
            },
            presetRanges: ref([
                {label: 'Today', range: [new Date(), new Date()]},
                {label: 'Yesterday', range: [startOfYesterday(), endOfYesterday()]},
                {label: 'Last 3 Days', range: [subDays(new Date(), 2), new Date()]},
                {label: 'Last 7 Days', range: [subDays(new Date(), 6), new Date()]},
                {label: 'This month', range: [startOfMonth(new Date()), new Date()]},
                {
                    label: 'Last month',
                    range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
                },
                {
                    label: 'Last 3 months',
                    range: [startOfMonth(subMonths(new Date(), 3)), new Date()],
                },
                {
                    label: 'Last 6 months',
                    range: [startOfMonth(subMonths(new Date(), 6)), new Date()],
                },
                {label: 'This year', range: [startOfYear(new Date()), new Date()]},
                {
                    label: 'Last year',
                    range: [startOfYear(subYears(new Date(), 1)), endOfYear(subYears(new Date(), 1))]
                },
                {
                    label: 'All Times',
                    range: [startOfYear(subYears(new Date(), 1)), new Date()]
                },
            ]),
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/orders', pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },

        BindOrderStatus: function (status) {
            if (status === "completed" || status === "Paid") {
                return "complete_status";
            } else if (status === "Failed" || status === "Cancelled" || status === "Rejected") {
                return "rejected_status"
            } else {
                return "pending_status"
            }
        },
    },
}
</script>



